import React, { Component } from "react";

import { Container, Form } from "react-bootstrap";
import CreatePaper from "../../../../src/images/create_paper.png";
import UploadOMR from "../../../../src/images/upload_OMR.png";
import ResultOMR from "../../../../src/images/result_OMR.png";
import EvaluationOMR from "../../../../src/images/evaluation.png";
import SampleOMR from "../../../../src/images/Sample_OMR.png";
import "./_newomr.scss";
import { withRouter } from 'react-router-dom';

import NewOmrHistory from "./NewOmrHistory";
import NewOmrUpload from "./NewOmrUpload";
import NewOmrDload from "./NewOmrDload";

const menuItems = [
  {
    title: "Exam Creation",
    imgSrc: CreatePaper,
    link: "/offline_exams/exam_made_easy",
    i: "#a955ff",
    j: "#ea51ff",
  },
  {
    title: "Download OMR",
    imgSrc: SampleOMR,
    link: "/offline_exams/omr/download",
    i: "#56CCF2",
    j: "#2F80ED",
  },
  {
    title: "Upload OMR Files",
    imgSrc: UploadOMR,
    link: "/offline_exams/omr/upload",
    i: "#FF9966",
    j: "#FF5E62",
  },
  {
    title: "OMR Evaluation",
    imgSrc: EvaluationOMR,
    link: "/offline_exams/omr/history",
    i: "#80FF72",
    j: "#7EE8FA",
  },
  {
    title: "Results",
    imgSrc: ResultOMR,
    link: "/offline_exams/ExamReport",
    i: "#ffa9c6",
    j: "#f434e2",
  },
];

class NewMainOmr extends Component {
  constructor(props) {
    super(props);
    const componentFromPath = this.getComponentFromPath(props.location.pathname);
    this.state = {
      selectedButton: componentFromPath,
      component: componentFromPath,
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.location.pathname !== prevProps.location.pathname) {
      const componentFromPath = this.getComponentFromPath(this.props.location.pathname);
      this.setState({ selectedButton: componentFromPath, component: componentFromPath });
    }
  }

  getComponentFromPath(pathname) {
    const lastSegment = pathname.split("/").filter(Boolean).pop();
    if (["history", "upload", "download"].includes(lastSegment)) {
      return lastSegment;
    }
    return "history"; // default
  }

  handleClick = (btn) => {
    const basePath = this.props.match.url.split("/").slice(0, -1).join("/") || "";
    this.props.history.push(`${basePath}/${btn}`);
  };

  render() {
    const { selectedButton } = this.state;

    let RenderComponent;
    switch (this.state.component) {
      case "upload":
        RenderComponent = <NewOmrUpload />;
        break;
      case "download":
        RenderComponent = <NewOmrDload />;
        break;
      default:
        RenderComponent = <NewOmrHistory />;
        break;
    }

    return (
      <Container className="managing_offline_overview mt-3">
        <h4 className="text-black text-center mt-3">OMR Flow</h4>
        <div className="omr-menu-wrapper" style={{ marginTop: "30px", marginBottom: "30px" }}>
          <ul className="glow-menu">
            {menuItems.map((item, index) => (
              <li key={index} className="omr-step-item" style={{ "--i": item.i, "--j": item.j }}>
                <div className="menu-shape">
                  <a href={item.link} className="menu-link">
                    <span className="icon">
                      <img src={item.imgSrc} alt={item.title} className="menu-img" />
                    </span>
                    <span className="label-title">{item.title}</span>
                    <span className="title">{item.title}</span>
                  </a>
                </div>
                <div className="step-label">Step {index + 1}</div>
              </li>
            ))}
          </ul>
        </div>

        <Container style={{ background: "#ffffff" }}>
          <Form className="mt-5">
            <Form.Group className="d-flex align-items-center justify-content-between flex-wrap">
              <div className="choice selection">
                <button
                  type="button"
                  className={`omr-btn ${selectedButton === "history" ? "active" : ""}`}
                  onClick={() => this.handleClick("history")}
                >
                  OMR Upload History
                </button>
                <button
                  type="button"
                  className={`omr-btn ml-3 ${selectedButton === "upload" ? "active" : ""}`}
                  onClick={() => this.handleClick("upload")}
                >
                  Upload OMR
                </button>
                <button
                  type="button"
                  className={`omr-btn ml-4 ${selectedButton === "download" ? "active" : ""}`}
                  onClick={() => this.handleClick("download")}
                >
                  Download Sample OMR
                </button>
              </div>
            </Form.Group>
          </Form>
          {RenderComponent}
        </Container>
      </Container>
    );
  }
}
export default withRouter(NewMainOmr);